import {
  getExperimentVariantOverride,
  readExperimentVariant,
} from './posthogExperiment';

// PostHog A/B experiment on the /pricing plan tiles (ORA-392). Variants:
//   control  -> current trial-forward tiles ("$0 due today", price pill)
//   redesign -> price-forward tiles: crossed-out base price over the
//               discounted price, discount + savings pills, "$0 due today"
//               fine print under the CTA
export const PRICING_PAGE_EXPERIMENT_FLAG = 'pricing-page-tiles-test';

export type PricingPageVariant = 'control' | 'redesign';

const VALID_VARIANTS = ['control', 'redesign'] as const;

// Local/QA override via `?ppVariant=control|redesign`.
// When present it bypasses PostHog entirely (no flag read, so no real
// exposure), which lets each arm be forced locally — where PostHog never
// initializes — and on deployed previews without polluting experiment results.
export const getPricingPageVariantOverride = (): PricingPageVariant | null =>
  getExperimentVariantOverride('ppVariant', VALID_VARIANTS);

// Reads the experiment variant from PostHog, which FIRES the exposure event
// (`$feature_flag_called`) — so this is only called from the pricing page,
// where exposure genuinely happened. Logged-out visitors are bucketed on
// their anonymous id (sticky for the device); logged-in users are identified
// first so the variant follows their real id across sessions. Falls back to
// `control` outside production, when PostHog is disabled (EU), or on any
// error.
export const readPricingPageVariant = async (
  userId?: string | null
): Promise<PricingPageVariant> =>
  readExperimentVariant({
    flag: PRICING_PAGE_EXPERIMENT_FLAG,
    validVariants: VALID_VARIANTS,
    fallback: 'control',
    userId,
  });
